import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimeFlagComponent } from './prime-flag.component';
import { RouterModule } from '@angular/router';
import { MultiCountryCurrencyModule } from '../../../pipes/multi-country-currency/multi-country-currency.module';



@NgModule({
  declarations: [PrimeFlagComponent],
  imports: [
    CommonModule,
    RouterModule,
    MultiCountryCurrencyModule
  ],
  exports:[
    PrimeFlagComponent
  ]
})
export class PrimeFlagModule { }
